<aside class="page-sidebar h-100"
       [ngClass]="{'disable-slide': loginResponse?.disableLoginPageCards}">
    <header class="text-white text-center">
        <h4>{{configuredLoginTitle}}</h4>
        <p>{{configuredLoginSubtitle}}</p>
    </header>
    <section class="text-center">
        <gt-user-greeting></gt-user-greeting>
    </section>
    <ng-container *ngIf="!loginResponse?.disableLoginPageCards">
        <div class="border-bottom border-white w-100"></div>
        <div class="sidebar-carousel">
            <ngx-hm-carousel
                    *ngIf="assets"
                    [autoplay]="autoplay"
                    [infinite]="infinite"
                    [autoplay-speed]="slideInterval"
                    [between-delay]="2000"
                    class="carousel c-accent">

                <section ngx-hm-carousel-container class="content">
                    <article class="item cursor-pointer"
                             ngx-hm-carousel-item
                             *ngFor="let asset of assets; let i = index">
                        <img [src]="getImageSrc(asset)">
                        <div class="mt-3 text-white">
                            <p class="title mb-2">{{asset.title}}</p>
                            <div class="lead">
                                <h6>{{asset?.text}}</h6>
                                <a [href]="asset?.url" target="_blank"
                                   class="btn btn-link p-0 d-flex align-items-center">
                                    <div>{{(asset?.ctatext || 'learn more' )| uppercase }}</div>
                                    <div class="gt-icon gt-icon-arrow-right ml-2"></div>
                                </a>
                            </div>
                        </div>
                    </article>
                </section>

                <ng-template #carouselDot let-model>
                    <div class="ball bg-accent"
                         [class.visible]="model.index === model.currentIndex"></div>
                </ng-template>

            </ngx-hm-carousel>
        </div>
    </ng-container>
</aside>
